import React, { useState,useEffect } from "react";

const SettingTab = ({updateClickToCallTabData, clickToCallTabData}) => {
    const [activeSeetingElementsTab, setActiveSeetingElementsTab] = useState("main");
    const [displayPagesType, setDisplayPagesType] = useState(clickToCallTabData.setting_pages_type);
    const [selectedDevices, setSelectedDevices] = useState(clickToCallTabData.setting_devices_type || []);
    const [displayVisitors, setDisplayVisitors] = useState(clickToCallTabData.setting_visitors_type);
    const [selectedScheduleDays, setScheduleDays] = useState(clickToCallTabData.setting_schedule_days || []);
    const [showShowTimeSchedule, setShowTimeSchedule] = useState(Number(clickToCallTabData.setting_schedule_is_set_the_time_schedule));
    const [showShowOnPageLoad, setShowOnPageLoad] = useState(Number(clickToCallTabData.setting_open_call_window_triggers_is_on_page_load));
    const [showShowExitIntent, setShowExitIntent] = useState(Number(clickToCallTabData.setting_open_call_window_triggers_is_exit_intent));

    //Time Schedule Start Time
    const [selectedSTartTimeTimeSchedule, setSelectedSTartTimeTimeSchedule] = useState(clickToCallTabData.setting_schedule_start_time);
    const [showSTartTimeTimeScheduleDropdown, setShowSTartTimeTimeScheduleDropdown] = useState(false);
    const layoutSTartTimeTimeScheduleValues = ['12:00 AM', '1:00 AM','2:00 AM','3:00 AM','4:00 AM','5:00 AM','6:00 AM','7:00 AM','8:00 AM','9:00 AM','10:00 AM','11:00 AM'];
    const toggleSTartTimeTimeScheduleDropdown = () => {
        setShowSTartTimeTimeScheduleDropdown(!showSTartTimeTimeScheduleDropdown);
    };
    const handleSTartTimeTimeScheduleSelect = (spacing) => {
        setSelectedSTartTimeTimeSchedule(spacing);
        setShowSTartTimeTimeScheduleDropdown(false);
        updateClickToCallTabData("setting_schedule_start_time", spacing);
    };

    //Time Schedule End Time
    const [selectedEndTimeTimeSchedule, setSelectedEndTimeTimeSchedule] = useState(clickToCallTabData.setting_schedule_end_time);
    const [showEndTimeTimeScheduleDropdown, setShowEndTimeTimeScheduleDropdown] = useState(false);
    const layoutEndTimeTimeScheduleValues = ['12:00 AM', '1:00 AM','2:00 AM','3:00 AM','4:00 AM','5:00 AM','6:00 AM','7:00 AM','8:00 AM','9:00 AM','10:00 AM','11:00 AM'];
    const toggleEndTimeTimeScheduleDropdown = () => {
        setShowEndTimeTimeScheduleDropdown(!showEndTimeTimeScheduleDropdown);
    };
    const handleEndTimeTimeScheduleSelect = (spacing) => {
        setSelectedEndTimeTimeSchedule(spacing);
        setShowEndTimeTimeScheduleDropdown(false);
        updateClickToCallTabData("setting_schedule_end_time", spacing);
    };

    // Handlers Where to Display Chat Change
    const handleDisplayPagesTypeChange = (event) => {
        const value = event.target.value;
        setDisplayPagesType(value);
        updateClickToCallTabData("setting_pages_type", value);
    };

    // UseEffect Display Chat on Devices Change
    useEffect(() => {
        // Sync state if clickToCallTabData updates from outside
        if (Array.isArray(clickToCallTabData.setting_devices_type)) {
          setSelectedDevices(clickToCallTabData.setting_devices_type);
        } else if (typeof clickToCallTabData.setting_devices_type === 'string') {
          try {
            const parsed = JSON.parse(clickToCallTabData.setting_devices_type);
            setSelectedDevices(parsed);
          } catch (e) {
            // Fallback if not a valid JSON string
            const devicesFromString = clickToCallTabData.setting_devices_type.split(',').map(item => item.trim());
            setSelectedDevices(devicesFromString);
          }
        }
    }, [clickToCallTabData.setting_devices_type]); 

    // Handlers Display Chat on Devices Change
    const handleDeviceChange = (event) => {
        const { value, checked } = event.target;
        let updatedDevices = [...selectedDevices];
    
        if (checked) {
          if (!updatedDevices.includes(value)) {
            updatedDevices.push(value);
          }
        } else {
          updatedDevices = updatedDevices.filter(device => device !== value);
        }
    
        setSelectedDevices(updatedDevices);
        updateClickToCallTabData("setting_devices_type", JSON.stringify(updatedDevices));
    };

    // Handlers Display for Visitors Change
    const handleDisplayVisitorsChange = (event) => {
        const value = event.target.value;
        setDisplayVisitors(value);
        updateClickToCallTabData("setting_visitors_type", value);
    };

    // UseEffect When to Schedule Days Change
        useEffect(() => {
        // Sync state if clickToCallTabData updates from outside
        if (Array.isArray(clickToCallTabData.setting_schedule_days)) {
            setScheduleDays(clickToCallTabData.setting_schedule_days);
        } else if (typeof clickToCallTabData.setting_schedule_days === 'string') {
            try {
            const days_parsed = JSON.parse(clickToCallTabData.setting_schedule_days);
            setScheduleDays(days_parsed);
            } catch (e) {
            // Fallback if not a valid JSON string
            const daysFromString = clickToCallTabData.setting_schedule_days.split(',').map(item => item.trim());
            setScheduleDays(daysFromString);
            }
        }
    }, [clickToCallTabData.setting_schedule_days]); 

    // Handlers Schedule Days Change
    const handleScheduleDaysChange = (event) => {
        const { value, checked } = event.target;
        let updatedScheduleDays = [...selectedScheduleDays];
    
        if (checked) {
            if (!updatedScheduleDays.includes(value)) {
                updatedScheduleDays.push(value);
            }
        } else {
            updatedScheduleDays = updatedScheduleDays.filter(device => device !== value);
        }
    
        setScheduleDays(updatedScheduleDays);
        updateClickToCallTabData("setting_schedule_days", JSON.stringify(updatedScheduleDays));
    };

    // Handlers Show Time Schedule Change
    const handleShowTimeScheduleChange = (e) => {
        const checked = e.target.checked;
        setShowTimeSchedule(checked);
        updateClickToCallTabData("setting_schedule_is_set_the_time_schedule", checked); 
    };

    // Handlers Show On Page Load Change
    const handleShowOnPageLoadChange = (e) => {
        const checked = e.target.checked;
        setShowOnPageLoad(checked);
        updateClickToCallTabData("setting_open_call_window_triggers_is_on_page_load", checked); 
    };

    // Handlers Show Exit Intent Change
    const handleShowExitIntentChange = (e) => {
        const checked = e.target.checked;
        setShowExitIntent(checked);
        updateClickToCallTabData("setting_open_call_window_triggers_is_exit_intent", checked); 
    };

    return (
        <div className="click-to-call-side-baar-setting-tab">
            {activeSeetingElementsTab === "main" && (
                <>
                    <span>Settings</span>
                    <div className="name-tile-row">Widget Display Conditions</div>
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveSeetingElementsTab("pages")}>Pages <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSeetingElementsTab("devices")}>Devices <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSeetingElementsTab("visitors")}>Visitors <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSeetingElementsTab("schedule")}>Schedule <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div>
                    <p>Activate/deactivate the widget depending on specific parameters.</p>
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveSeetingElementsTab("open_call_window")}>Open Call Window Triggers <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div>
                    <p>Set the type of visitor behavior that will open the call window to encourage the visitor to call you.</p>
                </>
            )}

            {activeSeetingElementsTab === "pages" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSeetingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Pages</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <ul className="pages-list">
                                    <li>
                                        <div className="form-group">
                                            <input id="all_pages" type="radio" value="All_Pages" onChange={handleDisplayPagesTypeChange} checked={displayPagesType === 'All_Pages'}/>
                                            <label for="all_pages">All Pages</label>
                                        </div>
                                    </li>
                                   {/* <li>
                                        <div className="form-group">
                                            <input id="exclude_pages" type="radio" value="Exclude_Pages" onChange={handleDisplayPagesTypeChange} checked={displayPagesType === 'Exclude_Pages'} />
                                            <label for="exclude_pages">Exclude Pages</label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-group">
                                            <input id="specific_pages" type="radio" value="Specific_Pages" onChange={handleDisplayPagesTypeChange} checked={displayPagesType === 'Specific_Pages'} />
                                            <label for="specific_pages">Specific Pages</label>
                                        </div>
                                    </li>*/}
                                </ul>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeSeetingElementsTab === "devices" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSeetingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Devices</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <ul className="pages-list">
                                    <li>
                                        <div className="form-group">
                                            <input id="desktop_device" type="checkbox" value="Desktop" checked={selectedDevices.includes("Desktop")} onChange={handleDeviceChange}/>
                                            <label for="desktop_device">Desktop</label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-group">
                                            <input id="tablets_device" type="checkbox" value="Tablets" checked={selectedDevices.includes("Tablets")} onChange={handleDeviceChange} />
                                            <label for="tablets_device">Tablets</label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-group">
                                            <input id="phones_device" type="checkbox" value="Phones" checked={selectedDevices.includes("Phones")} onChange={handleDeviceChange} />
                                            <label for="phones_device">Phones</label>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <p>Choose the type of device to display your widget on.</p>
                    </div>
                </>
            )}

            {activeSeetingElementsTab === "visitors" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSeetingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Visitors</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <ul className="pages-list">
                                    <li>
                                        <div className="form-group">
                                            <input id="visitors_all_pages" type="radio" value="All_Pages" onChange={handleDisplayVisitorsChange} checked={displayVisitors === 'All_Pages'} />
                                            <label for="visitors_all_pages">All Pages</label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-group">
                                            <input id="visitors_exclude_pages" type="radio" value="Exclude_Pages" onChange={handleDisplayVisitorsChange} checked={displayVisitors === 'Exclude_Pages'} />
                                            <label for="visitors_exclude_pages">Exclude Pages</label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-group">
                                            <input id="specific_exclude_pages" type="radio" value="Specific_Pages" onChange={handleDisplayVisitorsChange} checked={displayVisitors === 'Specific_Pages'} />
                                            <label for="specific_exclude_pages">Specific Pages</label>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <p>Select the category of visitors you want to display the widget for: all visitors, visitors who have come to your website for the first time, visitors who had been on your website before.</p>
                    </div>
                </>
            )}

            {activeSeetingElementsTab === "schedule" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSeetingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Schedule</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <p>Position</p>
                                <ul>
                                    <li>
                                        <div className="form-group">
                                            <input id="chat_monday" type="checkbox" value="Monday" checked={selectedScheduleDays.includes("Monday")} onChange={handleScheduleDaysChange} />
                                            <label for="chat_monday">Monday</label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-group">
                                            <input id="chat_tuesday" type="checkbox" value="Tuesday" checked={selectedScheduleDays.includes("Tuesday")} onChange={handleScheduleDaysChange} />
                                            <label for="chat_tuesday">Tuesday</label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-group">
                                            <input id="chat_wednesday" type="checkbox" value="Wednesday" checked={selectedScheduleDays.includes("Wednesday")} onChange={handleScheduleDaysChange} />
                                            <label for="chat_wednesday">Wednesday</label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-group">
                                            <input id="chat_thursday" type="checkbox" value="Thursday" checked={selectedScheduleDays.includes("Thursday")} onChange={handleScheduleDaysChange}/>
                                            <label for="chat_thursday">Thursday</label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-group">
                                            <input id="chat_friday" type="checkbox" value="Friday" checked={selectedScheduleDays.includes("Friday")} onChange={handleScheduleDaysChange} />
                                            <label for="chat_friday">Friday</label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-group">
                                            <input id="chat_saturday" type="checkbox" value="Saturday" checked={selectedScheduleDays.includes("Saturday")} onChange={handleScheduleDaysChange} />
                                            <label for="chat_saturday">Saturday</label>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="form-group">
                                            <input id="chat_sunday" type="checkbox" value="Sunday" checked={selectedScheduleDays.includes("Sunday")} onChange={handleScheduleDaysChange} />
                                            <label for="chat_sunday">Sunday</label>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <p>Check the days when you need the widget to be active.</p>
                        <div className="side-baar-box-header">
                            <div className="box-header-row last-border-none"><span>Set the Time Schedule</span>
                                <div className="form-group">
                                    <input id="time_schedule_toggle" className="chkbx-toggle" type="checkbox" checked={showShowTimeSchedule} onChange={handleShowTimeScheduleChange}/>
                                    <label for="time_schedule_toggle"></label>
                                </div>
                            </div>
                        </div>
                        {Number(clickToCallTabData.setting_schedule_is_set_the_time_schedule) === 1 && (
                            <>
                                <div className="box-header-row">
                                    <span>Start Time</span>
                                    <em onClick={toggleSTartTimeTimeScheduleDropdown}>{selectedSTartTimeTimeSchedule}</em>
                                    {showSTartTimeTimeScheduleDropdown && (
                                        <ul className="dropdown-list">
                                            {layoutSTartTimeTimeScheduleValues.map((spacing) => (
                                                <li key={spacing} onClick={() => handleSTartTimeTimeScheduleSelect(spacing)}>
                                                    {spacing}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                                <div className="box-header-row">
                                    <span>End Time</span>
                                    <em onClick={toggleEndTimeTimeScheduleDropdown}>{selectedEndTimeTimeSchedule}</em>
                                    {showEndTimeTimeScheduleDropdown && (
                                        <ul className="dropdown-list">
                                            {layoutEndTimeTimeScheduleValues.map((spacing) => (
                                                <li key={spacing} onClick={() => handleEndTimeTimeScheduleSelect(spacing)}>
                                                    {spacing}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </>
                        )}
                        <p>Set the working time for the widget on the days you've checked in the section above.</p>
                    </div>
                </>
            )}

            {activeSeetingElementsTab === "open_call_window" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSeetingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button>Triggers</span>
                        <div className="box-header-row"><span>On Page Load</span>
                            <div className="form-group">
                                <input id="open_chat_on_page_load_toggle" className="chkbx-toggle" type="checkbox" checked={showShowOnPageLoad} onChange={handleShowOnPageLoadChange} />
                                <label for="open_chat_on_page_load_toggle"></label>
                            </div>
                        </div>
                        {/*<div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Time on Page</span>
                                <em>0sec</em>
                            </div>
                        </div>
                        <p>Open call window after a visitor spends a specific amount of time (in seconds) on the page.</p>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Time on Site</span>
                                <em>0sec</em>
                            </div>
                        </div>
                        <p>Open call window after a visitor spends a specific amount of time (in seconds) on the website.</p>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Scroll Position</span>
                                <em>0%</em>
                            </div>
                        </div>
                        <p>Open call window after a visitor has scrolled over a specific percentage of the page.</p>*/}
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Exit Intent</span>
                                <div className="form-group">
                                    <input id="chat_triger_exit_intent_toggle" className="chkbx-toggle" type="checkbox" checked={showShowExitIntent} onChange={handleShowExitIntentChange}/>
                                    <label for="chat_triger_exit_intent_toggle"></label>
                                </div>
                            </div>
                        </div>
                        <p>Open call window after a visitor has scrolled over a specific percentage of the page.</p>
                    </div>
                </>
            )}

        </div>
    );
};

export default SettingTab;